import * as z from "zod";

export const getPublicKey = {
  name: "getPublicKey" as const,
  input: z.object({ domain: z.string().nullish() }),
  output: z.object({ publicKey: z.string() }),
};
